import FuseUtils from '@fuse/utils';
import moment from 'moment';
import NP from 'number-precision';

export const calculaDiferencaParcelasUtil = (parcelas, valorTotal = 0) => {
  let diferenca = 0;

  const valorParcelas = parcelas
    .map((parcela) => parcela.valorParcela)
    .reduce((acc, valorParcela) => NP.plus(acc, valorParcela));

  if (valorTotal > valorParcelas) {
    diferenca = NP.minus(valorTotal.toFixed(2), valorParcelas);
  } else {
    diferenca = NP.minus(valorParcelas, valorTotal.toFixed(2));
  }

  return diferenca;
};

/*
RNE-105 - Sobre a exibição das parcelas da despesa : Public <<Functional>> Feature

Observação: Caso seja informado o dia 30 ou 31 no parcelamento, o sistema deve considerar 
o último dia do mês para os meses que não possuem 30 e 31.
*/
export const gerarParcelas = (quantidade, dataPrimeiraParcela, valorTotal = 0) => {
  const parcelas = [];

  let vencimentoAnterior = dataPrimeiraParcela;

  if (!moment.isMoment(vencimentoAnterior)) {
    vencimentoAnterior = moment(vencimentoAnterior);
  }

  const valorParcela = NP.round(NP.divide(valorTotal, quantidade), 2);

  const diferencaCentavos = NP.round(NP.minus(valorTotal, NP.times(valorParcela, quantidade)), 2);

  for (let i = 0; i < (quantidade || 0); ++i) {
    const dataVencimento = vencimentoAnterior.clone();
    let valorComArredondamento = valorParcela;

    if (i === 0) {
      valorComArredondamento = NP.plus(valorParcela, diferencaCentavos);
    }

    if (i > 0) {
      dataVencimento.add(30, 'day');
    }
    parcelas.push({ key: FuseUtils.generateGUID(), valorParcela: valorComArredondamento, dataVencimento });

    vencimentoAnterior = dataVencimento;
  }
  return parcelas;
};

export const alterarParcelasSubsequentes = (parcelas, primeiraDataVencimento) => {
  const _dataVencimento = primeiraDataVencimento.clone();

  return parcelas.map((parcela, index) => {
    let dataVencimento = _dataVencimento.clone();
    if (index > 0) {
      dataVencimento = _dataVencimento.add(30, 'day').clone();
    }

    return {
      ...parcela,
      dataVencimento,
    };
  });
};
